<template>
  <el-container direction="vertical" id="personnelCorrecting">
    <el-main>
      <el-col :span="16" :push="4">
        <el-form label-width="150px" style="text-align: left;">
          <el-card class="box-card">
            <div class="box-card-div-title userInfo"><div class="header">人员变更系统核保</div></div>
            <el-form-item class="form-item-label" label="保单号">
              <div class="rightUnit">{{accode}}</div>
            </el-form-item>
            <el-form-item class="form-item-label" label="投保企业名称">
              <div class="rightUnit">{{dynamicValidateForm.companyName}}</div>
            </el-form-item>
            <el-form-item class="form-item-label" label="有效期间">
              <div class="rightUnit">{{orderInfoLog.effectiveDate}}  —— {{orderInfoLog.expireDate}}</div>
            </el-form-item>
            <el-form-item class="form-item-label" label="批改生效日期">
              <div class="rightUnit">{{correctingDate}}</div>
            </el-form-item>
            <el-form-item class="form-item-label addPersonnel " label="增加人员">
              <el-table
                ref="addPersonnelList"
                :data="endorInsuredAddList"
                border
                style="width: 100%;margin-bottom: 15px">
                <el-table-column
                  prop="name"
                  label="被保险人姓名"
                  width="110">
                </el-table-column>
                <el-table-column
                  label="性别"
                  width="60">
                  <template slot-scope="scope">
                    {{scope.row.sex == 'O' ? '其他' : (scope.row.sex == 'F' ? '女' : '男')}}
                  </template>
                </el-table-column>
                <el-table-column
                  width="100"
                  label="保障计划">
                  <template slot-scope="scope">
                    <div :style="{color: $$.isValidObj(scope.row.skuId) ? '' : '#FF7052'}" >
                      {{$$.isValidObj(scope.row.skuId) ? '保障计划'+supportPlan(scope.row.skuId, 0) : '未设置'}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="职业类别">
                  <template slot-scope="scope">
                    <div :style="{color: $$.isValidObj(scope.row.skuId) ? '' : '#FF7052'}" >
                      {{$$.isValidObj(scope.row.skuId) ? supportPlan(scope.row.skuId, 1) : '未设置'}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="idnumber"
                  width="170"
                  label="证件号码">
                </el-table-column>
                <el-table-column
                  width="100"
                  label="增加保费">
                  <template slot-scope="scope">
                    <div :style="{color: scope.row.insuMoney == 0 ? '#FF7052' : ''}" >
                      {{scope.row.insuMoney == 0 ? '——' : scope.row.insuMoney + '元'}}
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
            <el-form-item class="form-item-label addPersonnel " label="退保人员">
              <el-table
                :data="endorInsuredSubtractList"
                border
                style="width: 100%;margin-bottom: 15px">
                <el-table-column
                  prop="name"
                  label="被保险人姓名"
                  width="110">
                </el-table-column>
                <el-table-column
                  label="性别"
                  width="60">
                  <template slot-scope="scope">
                    {{scope.row.sex == 'O' ? '其他' : (scope.row.sex == 'F' ? '女' : '男')}}
                  </template>
                </el-table-column>
                <el-table-column
                  width="100"
                  label="保障计划">
                  <template slot-scope="scope">
                    <div :style="{color: $$.isValidObj(scope.row.skuId) ? '' : '#FF7052'}" >
                      {{$$.isValidObj(scope.row.skuId) ? '保障计划'+supportPlan(scope.row.skuId, 0) : '未设置'}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="职业类别">
                  <template slot-scope="scope">
                    <div :style="{color: $$.isValidObj(scope.row.skuId) ? '' : '#FF7052'}" >
                      {{$$.isValidObj(scope.row.skuId) ? supportPlan(scope.row.skuId, 1) : '未设置'}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="idnumber"
                  width="170"
                  label="证件号码">
                </el-table-column>
                <el-table-column
                  width="110"
                  label="减少保费">
                  <template slot-scope="scope">
                    <div :style="{color: scope.row.insuMoney == 0 ? '#FF7052' : ''}" >
                      {{scope.row.insuMoney == 0 ? '——' : scope.row.insuMoney + '元'}}
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
            <el-form-item class="form-item-label" label="加保人员数量合计">
              <div class="rightUnit">{{addHeadcount}}人</div>
            </el-form-item>
            <el-form-item class="form-item-label" label="加保人员保费合计">
              <div class="rightUnit">{{addTotalPremium}}元</div>
            </el-form-item>
            <el-form-item class="form-item-label" label="退保人员数量合计">
              <div class="rightUnit">{{subtractHeadcount}}人</div>
            </el-form-item>
            <el-form-item class="form-item-label" label="退保人员保费合计">
              <div class="rightUnit">{{subtractTotalPremium == 0 ? subtractTotalPremium : '-'+subtractTotalPremium}}元</div>
            </el-form-item>
            <el-form-item class="form-item-label" label="合计保费变更">
              <div class="rightUnit">{{totalPremium}}元</div>
            </el-form-item>
            <el-form-item class="form-item-label" :label="actualPremiumsName">
              <div class="rightUnit">{{actualPremiums}}元</div>
              <p class="warmPrompt" v-if="refundWarmPrompt">温馨提示：由于产生保费退费，需要补扣佣金{{paidInPremium}}元，佣金从钱包扣除</p>
            </el-form-item>
            <el-form-item label="收款账户" class="form-item-label" v-if="totalPremium < 0">
              <div class="rightUnit">{{bankAccount}}</div>
            </el-form-item>
          </el-card>
          <el-card class="box-card" v-if="totalPremium>0">
            <div class="box-card-div-title invoiceInformation"><div class="header">发票信息</div></div>
            <el-form-item label="是否需要" class="form-item-label-big">
              <el-radio-group v-model="needInvoices">
                <el-radio-button class="my-button" :disabled="true" :label="true">需要</el-radio-button>
                <el-radio-button class="my-button" :disabled="true" :label="false">不需要</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <span v-if="needInvoices">
              <el-form-item label="发票类型" class="form-item-label-big">
              <div>
                <el-radio-group v-model="receiptType">
                  <el-radio-button class="my-button" :disabled="true" :label="2">普通发票(电子发票)</el-radio-button>
                  <el-radio-button class="my-button" :disabled="true" :label="1">增值税专用发票（纸质发票）</el-radio-button>
                </el-radio-group>
              </div>
              </el-form-item>
              <span v-if="receiptType === 2">
                <el-form-item label="发票内容" class="form-item-label-big"></el-form-item>
                <el-form-item label="发票抬头" class="form-item-label">
                  <el-input :disabled="true" class="form-item-input my-input-left "
                            v-model="dynamicValidateForm.companyName"
                            placeholder="请输入发票抬头"
                  ></el-input>
                </el-form-item>
                <el-form-item label="纳税人识别号" class="form-item-label">
                  <el-input v-if="idType === 6" class="form-item-input my-input-left "
                            v-model="socialCreditCode"
                            :disabled="true"
                            placeholder="请输入纳税人识别号"
                  ></el-input>
                  <el-input v-else class="form-item-input my-input-left "
                            :disabled="true"
                            v-model="orderMailInvoiceInfo.tIN"
                            placeholder="请输入纳税人识别号"
                  ></el-input>
                </el-form-item>
                <el-form-item label="收件人信息" class="form-item-label-big"></el-form-item>
                <el-form-item label="收件人姓名" class="form-item-label">
                  <el-input class="form-item-input my-input-left "
                            :disabled="true"
                            v-model="orderMailInvoiceInfo.rName"
                            placeholder="请输入收件人姓名"
                  ></el-input>
                </el-form-item>
                <el-form-item label="收件人手机号" class="form-item-label">
                  <el-input class="form-item-input my-input-left "
                            :disabled="true"
                            v-model="orderMailInvoiceInfo.rPhone"
                            placeholder="请输入收件人手机号码"
                  ></el-input>
                </el-form-item>
                <el-form-item label="收件人邮箱" class="form-item-label">
                  <el-input class="form-item-input my-input-left "
                            :disabled="true"
                            v-model="orderMailInvoiceInfo.rMail"
                            placeholder="请输入收件人邮箱"
                  ></el-input>
                </el-form-item>
              </span>
              <span v-else-if="receiptType === 1">
                <el-form-item label="发票内容" class="form-item-label-big"></el-form-item>
                  <el-form-item label="发票抬头" class="form-item-label">
                    <el-input :disabled="true" class="form-item-input my-input-left "
                              v-model="dynamicValidateForm.companyName"
                              placeholder="请输入发票抬头"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="纳税人识别号" class="form-item-label">
                    <el-input v-if="idType === 6" class="form-item-input my-input-left "
                              v-model="socialCreditCode"
                              :disabled="true"
                              placeholder="请输入纳税人识别号"
                    ></el-input>
                    <el-input v-else class="form-item-input my-input-left "
                              :disabled="true"
                              v-model="orderMailInvoiceInfo.tIN"
                              placeholder="请输入纳税人识别号"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="税务登记地址" class="form-item-label">
                    <el-input class="form-item-input my-input-left "
                              :disabled="true"
                              v-model="orderMailInvoiceInfo.tRA"
                              placeholder="请输入税务登记地址"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="税务登记电话" class="form-item-label">
                    <el-input class="form-item-input my-input-left "
                              :disabled="true"
                              v-model="orderMailInvoiceInfo.tRT"
                              placeholder="请输入税务登记电话"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="开户银行" class="form-item-label">
                    <el-input class="form-item-input my-input-left "
                              :disabled="true"
                              v-model="orderMailInvoiceInfo.openBank"
                              placeholder="请输入开户银行"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="银行账户" class="form-item-label">
                    <el-input class="form-item-input my-input-left "
                              :disabled="true"
                              v-model="orderMailInvoiceInfo.bankNum"
                              placeholder="银行账户"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="收件人信息" class="form-item-label-big"></el-form-item>
                  <el-form-item label="收件人姓名" class="form-item-label">
                    <el-input class="form-item-input my-input-left "
                              :disabled="true"
                              v-model="orderMailInvoiceInfo.rName"
                              placeholder="请输入收件人姓名"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="收件人手机号" class="form-item-label">
                    <el-input class="form-item-input my-input-left "
                              :disabled="true"
                              v-model="orderMailInvoiceInfo.rPhone"
                              placeholder="请输入收件人手机号码"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="收件人地址" class="form-item-label">
                  <el-select v-model="orderMailInvoiceInfo.rProvinceId" placeholder="请选择"
                             :disabled="true"
                             class="form-item-input my-input">
                    <el-option
                      v-for="item in chinaArea"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select v-model="orderMailInvoiceInfo.rCityId" placeholder="请选择"
                             :disabled="true"
                             class="form-item-input my-input">
                    <el-option
                      v-for="item in orderMailInvoiceInfo.rCityList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select v-model="orderMailInvoiceInfo.rAreaId" placeholder="请选择"
                             :disabled="true"
                             class="form-item-input my-input">
                    <el-option
                      v-for="item in orderMailInvoiceInfo.rAreaList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  </el-form-item>
                  <el-form-item label="具体地址" class="form-item-label">
                    <el-input class="form-item-input my-input-left "
                              :disabled="true"
                              v-model="orderMailInvoiceInfo.rAddress"
                              placeholder="请输入具体地址"
                    ></el-input>
                  </el-form-item>
              </span>
            </span>
          </el-card>
          <div class="confirm">
            <el-button @click="lastStep" class="header-button-order-lastStep">上一步</el-button>
            <el-button @click="confirm" class="header-button-order-confirm">确认</el-button>
          </div>
        </el-form>
      </el-col>
    </el-main>
  </el-container>
</template>

<script type="text/javascript">
  export default {
    name: "personnelConfirmation",
    data() {
      return {
        accode: '',                       // 保单号
        endorInsuredAddList: [],          // 加载 - 保全增保被保人数据（）
        endorInsuredSubtractList: [],     // 加载 - 保全减保被保人数据（）
        orderId: null,                    // 加载 - 订单ID
        endorOrderId: null,               // 加载 - 保全ID
        orderEndorInfoLogEntity: null,    // 加载 - 保全实体
        insureEnsureDatum: [],            // 加载 - 保障计划
        insuredUserInfoList: [],          // 加载 - 原保单被保人数据
        insuredUserInfoNewList: [],       // 加载 - 新保单被保人数据
        orderInfoLog: {},                 // 订单详情
        planId: null,
        productId: null,
        moneyMap: {},
        orderEndorToken: null,            // 保全订单token(加密)
        correctingDate: '',               // 批改生效时间
        addHeadcount: 0,                  // 加保人员数量合计
        addTotalPremium: 0,               // 加保人员保费合计
        subtractHeadcount: 0,             // 退保人员数量合计
        subtractTotalPremium: 0,          // 退保人员保费合计
        totalPremium: 0,                  // 合计保费变更
        actualPremiums: 0,                // 实际支付/实际退费（保费）
        actualPremiumsName: '实际支付/实际退费',  // 实际支付/实际退费（名字）
        refundWarmPrompt: false,          // 退款的温馨提示
        paidInPremium: 0,                 // 退款的温馨提示 - 佣金
        bankAccount: '',                  // 退款收款账户
        needInvoices: false,              // 是否需要 - 发票信息
        receiptType: 2,                   // 发票类型
        idType: '',
        chinaArea: this.chinaLifeAccidentDistrict.chinaAreaList(),
        // -- 被保人列表
        beInsureTableData: [],
        cityId: '', // 	城市ID
        provinceId: '', // 	省份ID
        areaId: '', // 	地区ID
        cityName: '', // 	城市名称
        provinceName: '', // 	省份名称
        areaName: '', // 地区名称
        socialCreditCode: '', // 证件号码
        address: '', // 联系人具体地址
        specificAddress: '', // 公司具体地址
        mobile: '',// 联系人手机号
        legalPerson: '', // 联系人
        workEmail: '', // 联系人邮箱
        dynamicValidateForm: {
          cards: [{
            groupSize: '',
            occId: '',
            realityOccCode: '',
            //-- 职业参数
            occOneId: '',
            occTwoList: [],
            occTwoId: '',
            occThreeList: [],
            occThreeId: '',
            occOneName: '',
            occTwoName: '',
            occThreeName: '',
            //规格值列表数据
            hurtList: [],
            medicalList: [],
            allowanceList: [],
            //规格选项值
            hurtValue: '',
            medicalValue: '',
            allowanceValue: '',
            //职业id
            occupationId: 0,
            //职业类别
            azcnCode: 0,
            //取值获取规格值下拉选项
            pid: 0,
            topLevelId: 0,
            skuInfo: {},
          }],
          companyName: '',
          guaranteePeriod: "12个月",
          insuranceAge: "18-65周岁",
          occupationType: "1-5类",
          occOneList: [],
          //-- sku参数
          skuList: [],
          skuSpecList: [],
          skuRelationAddList: [],
          occupationList: [],
        },
        orderMailInvoiceInfo: {
          tIN: '', // 纳税人识别号
          rName: '', // 收件人姓名
          rPhone: '', // 收件人手机号
          rMail: '', // 收件人邮箱
          tRA: '', // 税务登记地址
          tRT: '', // 税务登记电话
          openBank: '', // 开户银行
          bankNum: '', // 银行账户
          rCityId: '', // 	城市ID
          rProvinceId: '', // 	省份ID
          rAreaId: '', // 	地区ID
          rAddress: '', // 收件人具体地址
        },
        submitData:{}
      }
    },
    methods: {
      //-- 加载保全详情
      correctingInfo() {
        this.axios.post('/management/orderEndorInfoLog/orderEndorInfoLog_preservingData', {
          orderEndorToken: this.orderEndorToken,
          changeEffectiveDate: this.$$.isValidObj(this.correctingDate) ? this.$$.dateFormat(this.correctingDate) : null
        }).then((response) => {
          if (response.data.success){
            const data = response.data.datas,
              {companyName, endorInsuredUserInfoList , insureEnsureDatum, insuredUserInfoList, orderEndorInfoLogEntity, orderInfoLog,
                orderMailInvoiceInfo, planId, productId, moneyMap, bankAccount} = data,
              {addInsureMoney, changingPremium, paidInPremium, reduceInsureMoney} = moneyMap;
            this.dynamicValidateForm.companyName = companyName;
            this.orderEndorInfoLogEntity = orderEndorInfoLogEntity;
            this.insureEnsureDatum = insureEnsureDatum;
            this.insuredUserInfoList = insuredUserInfoList;
            this.orderInfoLog = orderInfoLog;
            this.planId = planId;
            this.productId = productId;
            this.moneyMap = moneyMap;
            this.correctingDate = orderEndorInfoLogEntity.effectiveDate;

            if (this.$$.isValidObj(bankAccount)) this.bankAccount = bankAccount;

            //-- 保全订单状态必须为8：初始化、0：待确认、才能修改
            if (!(orderEndorInfoLogEntity.endorStatus == 0 || orderEndorInfoLogEntity.endorStatus == 8)){
              this.$confirm('当前订单状态不可编辑~', '温馨提示：', {
                showClose: false,
                closeOnClickModal: false,
                center: true,
                showCancelButton: false,
                confirmButtonText: '确认',
              }).then(() => {
                this.$router.push({name: 'correctingHistoryManagement', query:{type : "27"}});
              });
            }

            if (this.addDialogVisibleState == 0) this.insuredUserInfoNewList = insuredUserInfoList;

            if (this.$$.isValidObj(orderMailInvoiceInfo)) {
              this.needInvoices = true;
              const {rName, rPhone, rMail, remark, rAddress, rProvinceId, rCityId, rAreaId, receiptType} = orderMailInvoiceInfo,
                {tIN, tRT, tRA, bankNum, openBank} = JSON.parse(remark);

              let params = {rName, rPhone, rMail, rAddress};

              if (this.$$.isValidObj(tRT) && this.$$.isValidObj(tRA) && this.$$.isValidObj(bankNum) && this.$$.isValidObj(openBank)) {
                params = {...params, ...{tRT, tRA, bankNum, openBank, rProvinceId: rProvinceId.toString(), rCityId: rCityId.toString(), rAreaId: rAreaId.toString()}};
              }
              if (this.$$.isValidObj(tIN)) params.tIN = tIN;
              if (this.$$.isValidObj(receiptType)) this.receiptType = receiptType;

              this.orderMailInvoiceInfo = {
                ...this.orderMailInvoiceInfo,
                ...params,
              };

              if (this.$$.isValidObj(rProvinceId)){
                this.chinaArea.forEach(item => {
                  item.value === rProvinceId.toString() ? this.orderMailInvoiceInfo.rCityList = item.children : [];
                });

                this.orderMailInvoiceInfo.rCityList.forEach(item => {
                  item.value === rCityId.toString() ? this.orderMailInvoiceInfo.rAreaList = item.children : [];
                });
              }
            }


            this.orderId = orderEndorInfoLogEntity.orderId;
            this.endorOrderId = orderEndorInfoLogEntity.id;

            this.orderInfoLog.effectiveDate = this.orderInfoLog.effectiveDate.substring(0,10);
            this.orderInfoLog.expireDate = this.orderInfoLog.expireDate.substring(0,10);

            this.endorInsuredAddList = [];
            this.endorInsuredSubtractList = [];
            for (let i in endorInsuredUserInfoList){
              const {type} = endorInsuredUserInfoList[i];
              type == 0 ? this.endorInsuredAddList.push(endorInsuredUserInfoList[i]) : this.endorInsuredSubtractList.push(endorInsuredUserInfoList[i]);
            }

            this.addHeadcount = this.endorInsuredAddList.length;
            this.addTotalPremium = addInsureMoney;
            this.subtractHeadcount = this.endorInsuredSubtractList.length;
            this.subtractTotalPremium = reduceInsureMoney;
            this.totalPremium = changingPremium;
            this.actualPremiumsName = changingPremium.toString().indexOf('-') >= 0 ? '实际退费' : '实际支付';
            this.actualPremiums = changingPremium.toString().replace('-', '');
            this.refundWarmPrompt = Number(changingPremium) < 0 ? true : false;
            this.paidInPremium = paidInPremium;
          }
        });
      },
      //-- 获取 保障计划
      supportPlan(id, type = 0) {
        for (let i in this.insureEnsureDatum){
          const {skuId, skuProductSpecValueList} = this.insureEnsureDatum[i];
          if (skuId == id){
            switch (type) {
              case 0:{
                return this.$$.changeNumToHan(parseInt(i) + 1);
              }
              case 1:{
                for (let j in skuProductSpecValueList){
                  const {name, specName} = skuProductSpecValueList[j];
                  if (name == '选择职业') return specName;
                }
                break;
              }
            }
          }
        }
      },
      //-- 上一步
      lastStep() {
        this.$router.push({name: 'personnelCorrecting', params: {orderEndorToken: this.orderEndorToken}});
      },
      //-- 确认
      confirm() {
        let that = this;
        this.axios.post('/management/orderEndorInfoLog/submitOrderEndorInfo',this.submitData).then((response) => {
          let data = response.data;
          if (data.success) {
            this.$message.success('验证成功~');

            that.commissionDeduction();
          } else {
            this.$message.error(data.msg);
          }
        });
      },
      //--
      commissionDeduction() {
        let that = this;
        this.axios.post('/management/orderEndorInfoLog/orderEndorPaymentBefore?endorOrderToken=' + encodeURIComponent(decodeURIComponent(this.orderEndorToken))).then((response) => {
          let data = response.data;
          if (data.success) {
            let {state} = data.datas.commission;
            switch (state) {
              case -1:{
                that.$confirm('退保补扣佣金已从您的钱包扣除~', '温馨提示：', {
                  showClose: false,
                  closeOnClickModal: false,
                  center: true,
                  showCancelButton: false,
                  confirmButtonText: '确认',
                }).then(() => {
                  this.$router.push({name: 'personnelManagement', query:{insuranceIsGroup: "4"}});
                });
                break;
              }
              case 0:{
                that.$confirm('订单提交成功~', '温馨提示：', {
                  distinguishCancelAndClose: true,
                  showClose: false,
                  closeOnClickModal: false,
                  confirmButtonText: '查看保单批改列表',
                  cancelButtonText: '查看批单详情'
                }).then(() => {
                  that.$router.push({name: 'personnelManagement', query:{insuranceIsGroup: "4"}});
                }).catch(action => {
                  if (action == "cancel") {

                    that.$router.push({name: 'correctingHistoryDetails'});
                  }
                });
                break;
              }
              case 1:{
                that.$confirm('订单提交成功，前往支付~', '温馨提示：', {
                  showClose: false,
                  closeOnClickModal: false,
                  center: true,
                  showCancelButton: false,
                  confirmButtonText: '确认',
                }).then(() => {
                  let params = {
                    orderEndorToken: this.orderEndorToken,
                    accode: this.accode,
                  };
                  sessionStorage.setItem('securityPaymentParams', JSON.stringify(params));
                  that.$router.push({name: 'securityPayment'});
                });
                break;
              }
            }
          } else {
            this.$message.error(data.msg);
          }
        });
      }
    },
    mounted() {
      let params = sessionStorage.getItem('personnelConfirmationParams');
      if (this.$$.isValidObj(params)){
        params = JSON.parse(params);
        this.orderEndorToken = params.orderEndorToken;
        this.accode = params.accode;
        this.submitData = params;

        console.log(params);

        this.correctingInfo();
      }else {
        this.$confirm('当前订单参数错误，请重新进入~', '温馨提示：', {
          showClose: false,
          closeOnClickModal: false,
          center: true,
          showCancelButton: false,
          confirmButtonText: '确认',
        }).then(() => {
          this.$router.push({name: 'correctingHistoryManagement', query:{type : "27"}});
        });
      }
    }
  }
</script>

<style scoped>
  .box-card {
    width: auto;
    height: auto;
    padding: 20px;
    margin-bottom: 2.5rem;
  }
  .box-card-div-title>.header {
    text-align: center;
    position: absolute;
    left: 0;
    top: -20px;
  }
  .box-card-div-title.userInfo {
    width: 192px;
  }
  .box-card-div-title.invoiceInformation {
    width: 96px;
  }
  .box-card-div-title {
    height: 12px;
    background: #FFBF00;
    font-size: 24px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 20px;
    display: inline-block;
    position: relative;
  }

  .form-item-label,
  .el-form-item{
    font-size: 1rem;
    font-weight: 500;
    color: #333333;
    margin: 0 auto 10px;
  }

  .form-item-label .rightUnit {
    width: 280px;
    padding: 0 10px;
    display: inline-block;
    background: #F7F7F7;
  }

  /deep/ .el-form-item__content{
    padding-left: 10px;
  }

  .warmPrompt{
    padding-left: 20px;
    font-size: 1rem;
    font-weight: 400;
    color: #FF7052;
    display: inline-block;
  }

  /deep/ .my-el-table {
    width: 900px;
  }

  .el-table /deep/ .cell {
    text-align: center;
  }

  .el-table /deep/ th{
    background: #EBEBEB!important;
    border-bottom: 1px solid #CCCCCC!important;
    border-right: 1px solid #CCCCCC!important;
  }

  /deep/ .el-table--border,
  /deep/ .el-table--group {
    border: 1px solid #CCCCCC!important;
  }

  .el-table /deep/ th>.cell{
    display: block;
  }

  .form-item-label-big /deep/ .el-form-item__label{
    font-size: 1.25rem !important;
    font-weight: bold;
  }

  .form-item-label /deep/ .el-form-item__label{
    font-size: 1rem!important;
    margin: 0 auto;
  }

  .form-item-label-big /deep/ .el-form-item__label {
    font-size: 20px !important;
  }

  /deep/ .el-form-item__content {
    padding-left: 10px;
  }
  .my-button {
    margin-right: 30px;
    background-color: #F7F7F7;
  }

  .my-button /deep/ .el-radio-button__inner {
    box-shadow: 0 0 0 0 !important;
    -webkit-box-shadow: 0 0 0 0 !important;
    border: 0;
    border-radius: 0 !important;
    background-color: #F7F7F7;
    color: #333333;
  }

  .is-active /deep/ .el-radio-button__inner {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    background-color: #FFEEEB !important;
    color: #FF7052 !important;
    border: 1px solid #FF7052 !important;
  }

  .confirm {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }
  .confirm button{
    margin: 0 30px;
    width: 15rem;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
  }

  .header-button-order-confirm,
  .header-button-order-confirm:hover{
    background: #FF7052 !important;
    color: #FFFFFF !important;
  }

  .header-button-order-lastStep,
  .header-button-order-lastStep:hover{
    color: #CCCCCC !important;
    background: #FFFFFF !important;
  }

  .my-input-left /deep/ .el-input__inner {
    max-width: 640px;
  }

  /deep/ .el-input__inner {
    max-width: 280px;
    border: 0 !important;
    font-size: 16px;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: left !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/chinaLifeAccidentInsurance/preservation/personnelConfirmation.vue